
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js/auto';
import { ChartConfiguration } from 'chart.js';

import { sharedState } from '../../../../framework/state';

import { CustomerReportVehicleTypeRow } from '../../../../../common/application/model/report/CustomerReportVehicleTypeRow';
import { chartBackgroundColors, doughnutChartOptions, numberTooltipCallbacks } from '../../../service/report_service';

@Component
export default class VehicleStateChart extends Vue {
    @Prop(Array) readonly rows!: CustomerReportVehicleTypeRow[];

    shared = sharedState;

    local = {
        stateChart: undefined as Chart | undefined,
    };

    mounted() {
        setTimeout(() => {
            this.addVehicleStateChart();
        }, 200);
    }

    @Watch('rows')
    rowsChanged() {
        if (this.local.stateChart && this.local.stateChart.data && this.local.stateChart.data.datasets) {
            this.local.stateChart.data.datasets[0].data = this.chartData;
            this.local.stateChart.update();
        }
    }

    private addVehicleStateChart() {
        const canvasContext = (document.getElementById('vehicle-state-chart-canvas') as HTMLCanvasElement)!!;

        const chartConfiguration: ChartConfiguration = {
            type: 'doughnut',
            data: {
                labels: [
                    this.$t('button.orders').toString(),
                    this.$t('enum.vehicleStatus.active').toString(),
                    this.$t('enum.vehicleStatus.ending').toString(),
                ],
                datasets: [
                    {
                        label: 'States',
                        data: this.chartData,
                        backgroundColor: [
                            VehicleStateChart.backgroundColors[0],
                            VehicleStateChart.backgroundColors[2],
                            VehicleStateChart.backgroundColors[4],
                        ],
                        borderWidth: 0,
                        hoverBorderColor: VehicleStateChart.backgroundColors[1],
                        hoverBorderWidth: 2,
                    },
                ],
            },
            options: {
                ...doughnutChartOptions,
                plugins: {
                    ...doughnutChartOptions.plugins,
                    tooltip: {
                        callbacks: { ...numberTooltipCallbacks },
                    },
                },
            },
        };

        this.local.stateChart = new Chart(canvasContext, chartConfiguration);
    }

    private static get backgroundColors(): string[] {
        return chartBackgroundColors;
    }

    private get chartData(): number[] {
        return [
            this.rows.map((r) => r.acquisition).reduce((a, b) => a + b, 0),
            this.rows.map((r) => r.active).reduce((a, b) => a + b, 0),
            this.rows.map((r) => r.ending).reduce((a, b) => a + b, 0),
        ];
    }
}
